<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <card>
            <form>
              <!-- <div class="row"> -->
              <!-- <div class="col-md-12"> -->
              <!-- Botanical name -->
              <div class="row">
                <div class="col-md-11">
                  <h4 slot="header" class="card-title">New article</h4>
                </div>

                <div class="col-md-1">
                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      :disabled="disabledSave"
                      @click.prevent="create"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="status" class="property-label">Status</label>
                    <select id="status" class="form-control" v-model="data.status">
                      <option value="1">Verified</option>
                      <option value="0">Not verified</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="isNew" class="property-label">Is New</label>
                    <input type="checkbox" v-model="data.isNew" :checked="data.isNew" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="status" class="property-label">Paid</label>
                    <select id="status" class="form-control" v-model="data.is_paid">
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="status" class="property-label">Type</label>
                    <v-select id="article_type" v-model="data.article_type" :clearable="false" :options="ARTICLE_TYPES">
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="row" v-if="data.article_type === 'YouTube'">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="status" class="property-label">Video URL</label>
                    <input
                      id="video_url"
                      v-model="data.video_url"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="title" class="property-label">Title</label>
                    <input
                      id="title"
                      v-model="data.title"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- sub_title -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="subtitle" class="property-label">subtitle</label>
                    <input
                      id="subtitle"
                      v-model="data.sub_title"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- categories -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="categories" class="property-label"
                      >Categories <span class="badge badge-secondary">Array</span>
                    </label>
                    <v-select
                      id="categories"
                      aria-describedby="addon-right addon-left"
                      v-model="data.categories"
                      :clearable="true"
                      :options="CATEGORIES_OPTIONS"
                      multiple
                    />
                  </div>
                </div>
              </div>

              <!-- collections -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="categories" class="property-label">Collection </label>
                    <v-select
                      id="categories"
                      aria-describedby="addon-right addon-left"
                      v-model="data.collection"
                      :clearable="false"
                      :options="COLLECTIONS_OPTIONS"
                    />
                  </div>
                </div>
              </div>
              <!-- Photo -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="subtitle" class="property-label">Preview image</label>
                    <card>
                      <span v-if="data.preview_img">
                        <img class="p-photo" v-bind:src="data.preview_img" />
                      </span>
                      <div>
                        <input ref="beforeFileInput" class="btn-file" type="file" @change="uploadFile($event)" />
                        <button
                          type="submit"
                          class="btn btn-info btn-fill"
                          @click.prevent="$refs.beforeFileInput.click()"
                        >
                          {{ data.preview_img ? 'Upload new' : 'Upload' }}
                        </button>
                        <div class="clearfix"></div>
                      </div>
                    </card>
                  </div>
                </div>
              </div>

              <!-- Add sections -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="common_names" class="property-label">Info Sections</label>
                    <button type="submit" class="btn btn-success btn-fill " @click.prevent="addSectionItem()">
                      Add section
                    </button>
                  </div>
                </div>
              </div>

              <!-- section -->
              <div v-for="(item, index) in data.sections" v-bind:key="index" class="row section-row">
                <!-- <card> -->
                <div class="row s-row">
                  <div class="col-md-2">
                    <h4>Section {{ index + 1 }}</h4>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-danger btn-fill " @click.prevent="removeSectionItem(index)">
                      Remove section
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title" class="property-label">Title</label>
                      <input
                        id="title"
                        v-model="data.sections[index].title"
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                      />
                    </div>
                  </div>
                </div>

                <!-- sub_title -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="subtitle" class="property-label">subtitle</label>
                      <input
                        id="subtitle"
                        v-model="data.sections[index].sub_title"
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                      />
                    </div>
                  </div>
                </div>

                <!-- Text -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="free_text" class="property-label">Text</label>
                      <button
                        type="submit"
                        class="btn btn-success btn-fill "
                        @click.prevent="addArrayItem('text', index)"
                      >
                        Add new line
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(item, t_index) in data.sections[index].text"
                  v-bind:key="index + '-' + t_index"
                  class="row"
                >
                  <div class="col-md-10">
                    <div class="form-group">
                      <MarkdownEditor
                        id="description"
                        left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link image"
                        v-model="data.sections[index].text[t_index]"
                        height="600px"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button
                      type="submit"
                      class="btn btn-danger btn-fill "
                      @click.prevent="removeArrayItem('text', index, t_index)"
                    >
                      X
                    </button>
                  </div>
                </div>

                <!-- Plant ID Link -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="plantId" class="property-label">Plant ID</label>
                      <input
                        id="plantId"
                        v-model="data.sections[index].plantId"
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                      />
                    </div>
                  </div>
                </div>

                <!-- Images -->
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="subtitle" class="property-label">images</label>
                      <card>
                        <div>
                          <input ref="beforeFileInputImg" type="file" @change="uploadFile($event, index)" />

                          <div class="clearfix"></div>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>

                <div v-if="data.sections[index].images.length > 0" class="row images-row">
                  <div
                    v-for="(image, image_index) in data.sections[index].images"
                    v-bind:key="image_index"
                    @click.prevent="removeImageItem(index, image_index)"
                    class="col-md-2 img-item"
                  >
                    <img alt="Remove" class="images-col" v-bind:src="data.sections[index].images[image_index]" />
                  </div>
                </div>

                <div
                  v-if="data.sections[index].aspect_ratio && data.sections[index].aspect_ratio.length > 0"
                  class="row images-row"
                >
                  <div
                    v-for="(image, image_index) in data.sections[index].aspect_ratio"
                    v-bind:key="image_index"
                    class="col-md-2 img-item"
                  >
                    <label for="subtitle" class="property-label">aspect ratio</label>
                    <input
                      id="aspect_ratio"
                      v-model="data.sections[index].aspect_ratio[image_index]"
                      class="form-control aspect-ratio"
                      aria-describedby="addon-right addon-left"
                      disabled
                    />
                  </div>
                </div>

                <!-- </card> -->
              </div>

              <!-- interesting_fact -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="interesting_fact" class="property-label">Interesting fact</label>
                    <textarea
                      id="interesting_fact"
                      v-model="data.interesting_fact"
                      class="form-control"
                      rows="5"
                      aria-describedby="addon-right addon-left"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Card from 'src/components/UIComponents/Cards/Card.vue'
import VMdEditor from '@kangc/v-md-editor'
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import enUS from '@kangc/v-md-editor/lib/lang/en-US'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import { COLLECTIONS } from './consts'

VMdEditor.lang.use('en-US', enUS)
VMdEditor.use(vuepressTheme)

export default {
  components: {
    Card,
    MarkdownEditor: VMdEditor,
  },
  data() {
    return {
      data: {
        title: '',
        sub_title: '',
        categories: [],
        preview_img: '',
        interesting_fact: '',
        sections: [],
        status: 0,
        is_paid: false,
        order: 999,
        collection: 'General',
      },
      ARTICLE_TYPES: ['Basic', 'Plant link', 'Gallery', 'YouTube'],
      CATEGORIES_OPTIONS: [
        'Care guides',
        'Light',
        'Water',
        'Fertilizing',
        'Repotting',
        'Soil',
        'Propagation',
        'Pruning',
        'Humidity',
        'Temperature',
        'Popular plants',
        'Toxicity',
        'Pests and diseases',
        'Seasons',
        'Pots',
        'Organizing',
        'Tools',
        'Holidays',
      ],
      COLLECTIONS_OPTIONS: COLLECTIONS,
      default_section: {
        title: '',
        sub_title: '',
        text: [''],
        order: 0,
        images: [],
        aspect_ratio: [],
        plantId: '',
      },
      disabledSave: false,
      token: localStorage.getItem('token'),
    }
  },
  created: function() {
    this.id = this.$route.params.id

    if (this.id) {
      this.getInfo(this.id)
    }
  },
  methods: {
    getInfo: async function() {
      let self = this
      let token = localStorage.getItem('token')

      const { data } = await axios.get(`${this.$hostname}/admin/articles/${self.id}`, {
        headers: {
          Authorization: token,
        },
      })

      self.data = data

      data.sections.forEach((section, idx) => {
        self.data.sections[idx].aspect_ratio = []

        section.images.forEach(image => {
          self.getMeta(image, (width, height) => {
            const aspect_ratio = (height / width).toFixed(3)
            if (aspect_ratio) {
              self.data.sections[idx].aspect_ratio.push(aspect_ratio)
            }
          })
        })
      })

      if (this.id) {
        document.title = `${data.title}`
      }
    },
    addArrayItem: function(field, s_index) {
      if (field === 'text') {
        this.data.sections[s_index].text.push('')
      }
    },
    removeArrayItem: function(field, s_index, t_index) {
      if (field === 'text') {
        this.data.sections[s_index].text.splice(t_index, 1)
      }
    },
    addSectionItem: function() {
      this.data.sections.push(JSON.parse(JSON.stringify(this.default_section)))
    },
    removeSectionItem: function(index) {
      this.data.sections.splice(index, 1)
    },
    removeImageItem: function(index, imgIndex) {
      this.data.sections[index].images.splice(imgIndex, 1)
      this.data.sections[index].aspect_ratio.splice(imgIndex, 1)
    },
    goBack: function() {
      window.history.back()
    },
    goList: function() {
      let route = this.$router.resolve({ path: `/articles` })
      window.open(route.href, '_blank')
    },
    getMeta: async function(url, callback) {
      const img = new Image()
      img.src = url
      img.onload = function() {
        callback(this.width, this.height)
      }
    },
    create: async function() {
      let self = this

      const isYoutubeType = this.data.article_type === 'YouTube'

      if (!this.data.title || !this.data.preview_img) {
        alert('Title or Image preview is required.')
        return
      }

      self.disabledSave = true
      this.$loading.show({ delay: 0 })

      const route = this.id ? `admin/articles/${this.id}/save` : 'admin/articles/create'

      const data = { ...this.data, video_url: isYoutubeType ? this.data.video_url : null }

      axios
        .post(`${this.$hostname}/${route}`, data, {
          headers: {
            Authorization: self.token,
          },
        })
        .then(function(response) {
          const notification = {
            template: `<span><b>Info saved</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-explore-2',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'info',
          })

          if (!self.id) {
            self.goList()
          } else {
            self.getInfo()
          }
        })
        .catch(function(error) {
          const notification = {
            template: `<span><b>${error.response.data.message}</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-simple-remove',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger',
          })
        })
        .finally(function() {
          self.disabledSave = false
          self.$loading.hide()
        })
    },
    uploadFile: function(event, section = null) {
      let self = this

      let formData = new FormData()

      formData.append('file', event.target.files[0])

      this.$loading.show({ delay: 0 })

      axios
        .post(`${this.$hostname}/admin/services/photo/upload`, formData, {
          headers: {
            Authorization: self.token,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function({ data }) {
          if (section !== null) {
            self.getMeta(data.url, (width, height) => {
              const aspect_ratio = (height / width).toFixed(3)
              if (aspect_ratio) {
                self.data.sections[section].aspect_ratio.push(aspect_ratio)
              }
            })
            self.data.sections[section].images.push(data.url)
          } else {
            self.data.preview_img = data.url
          }
        })
        .catch(function(error) {
          console.log(error)
          const notification = {
            template: `<span><b>Error uploading.</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-simple-remove',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger',
          })
        })
        .finally(function() {
          self.$loading.hide()
        })
    },
  },
}
</script>
<style scoped>
.property-label {
  font-size: 15px;
  color: black;
  font-weight: bold;
}
button:disabled,
button[disabled] {
  cursor: not-allowed;
}

.btn-save {
  width: 150px;
}

.col-md-4 {
  padding: 15px !important;
}

.checkbox-block {
  margin-top: 40px;
  margin-left: 40px;
}

.btn-file {
  display: none;
}

.image-block {
  max-width: 100%;
}

.form-check-inline {
  display: inline-block;
}

.label-checkbox {
  margin-right: 10px;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}
.card-body p {
  font-weight: 300;
  font-style: italic;
}

.card-body form {
  /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.preview-device {
  display: inline-block;
  width: 32%;
  margin-left: 10px;
}
.device-block {
  position: relative;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
}
.device-block.inactive {
  opacity: 0.5;
}
.device-block span {
  position: absolute;
  top: -30px;
  left: 5px;
}
.device-block img {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 18px;
  top: 18px;
}
.device1 {
  display: inline-block;
  /*width: 281px;*/
  /*height: 609px;*/
  width: 337px;
  height: 731px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 40px;
}
.device2 {
  display: inline-block;
  /*width: 310px;*/
  /*height: 552px;*/
  width: 372px;
  height: 662px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 50px;
}
.device3 {
  display: inline-block;
  /*width: 384px;*/
  /*height: 512px;*/
  width: 461px;
  height: 614px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 50px;
}
.mt30 {
  margin-top: 30px;
}

.aspect-ratio {
  width: 100px;
}
.p-photo {
  max-width: 100%;
  margin-bottom: 20px;
}
.section-row {
  border: 1px solid #e3e3e3;
  margin: 1px;
  padding: 20px;
  display: block;
}
.s-row {
  align-items: self-end;
}
.images-col {
  max-width: 100%;
  margin-bottom: 20px;
}
.images-row {
  border: 1px solid #e3e3e3;
  margin: 1px;
  padding: 20px;
  /* display: block;  */
}
.img-item {
  /* элемент тени */
  cursor: pointer;
  -webkit-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
}
.img-item:hover {
  /* элемент тени если наведен курсор */
  -webkit-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.3), 0 1px 0px rgba(0, 0, 0, 0.1);
  /* элемент тени если наведен курсор конец */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Articles/ArticleInfo.vue